export default __webpack_public_path__ + "static/img_2_1-42240d2fb2af3e3ee127db95de64d438.jpg";